import { Form, Row, Col, Button} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo } from "@fortawesome/free-solid-svg-icons";

const MeasurementFilters = ({ devices, measurementTypes, filters, setFilters, onSearch, onReset }) => {
    const handleStationChange = (station, isChecked) => {
        const stations = filters.stations || [];
        const newStations = isChecked
            ? [...stations, station.toString()]
            : stations.filter((s) => s !== station.toString());
        setFilters({ ...filters, stations: newStations });
    };

    return (
        <Form className="mt-5 ms-2 me-2" onSubmit={(e) => { e.preventDefault(); onSearch() }}>
            <Row className="g-3">
                {/* Device Filter */}
                <Col xs={12} md={6} lg={2}>
                    <Form.Group controlId="deviceFilter">
                        <Form.Label>Sort by Device</Form.Label>
                        <Form.Select
                            value={filters.device_id || ""}
                            onChange={(e) => setFilters({...filters, device_id: e.target.value})}
                            size="sm"
                        >
                            <option value=""> All Devices </option>
                            {devices.map((device) => (
                                <option key={device.id} value={device.id}>
                                    Device {device.device_id}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>

                {/* Measurement Type Filter */}
                <Col xs={12} md={6} lg={2}>
                    <Form.Group controlId="typeFilter">
                        <Form.Label>Sort by Measurement Type</Form.Label>
                        <Form.Select
                            value={filters.measurement_type || ""}
                            onChange={(e) => setFilters({...filters, measurement_type: e.target.value})}
                            size="sm"
                        >
                            <option value="">All Types</option>
                            {measurementTypes.map((type) => (
                                <option key={type.id} value={type.type_name}>
                                    {type.type_name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>

                {/* Time Sorting */}
                <Col xs={12} md={6} lg={2}>
                    <Form.Group controlId="timeSort">
                        <Form.Label>Sort by Time</Form.Label>
                        <Form.Select
                            value={filters.order || "desc"}
                            onChange={(e) => setFilters({...filters, order: e.target.value})}
                            size="sm"
                        >
                            <option value="desc"> Newest First</option>
                            <option value="asc"> Oldest First</option>
                        </Form.Select>
                    </Form.Group>
                </Col>

                {/* Status Filter */}
                <Col xs={12} md={6} lg={2}>
                    <Form.Group controlId="statusFilter">
                        <Form.Label>Sort by Status</Form.Label>
                        <Form.Select
                            value={filters.status|| ""}
                            onChange={(e) => setFilters({...filters, status: e.target.value})}
                            size="sm"
                        >
                            <option value="">All Status</option>
                            <option value="active">active</option>
                            <option value="completed">completed</option>
                        </Form.Select>
                    </Form.Group>
                </Col>

                {/* Stations Filter */}
                <Col xs={12} md={6} lg={2}>
                    <Form.Group controlId="stationFilter">
                        <Form.Label>Sort by Station</Form.Label>
                        <div className="d-flex flex-wrap gap-2">
                            {[1, 2, 3].map((station) => (
                                <Button
                                    key={station}
                                    variant={filters.stations?.includes(station.toString()) ? "primary" : "outline-primary"}
                                    size="sm"
                                    onClick={() => handleStationChange(
                                        station,
                                        !filters.stations?.includes(
                                            station.toString()
                                        )
                                    )}
                                >
                                    Station {station}
                                </Button>
                            ))}
                        </div>
                    </Form.Group>
                </Col>

                {/* Action Buttons */}
                <Col xs={12} md={6} lg={2} className="d-flex  align-items-end">
                    <Button variant="outline-secondary" onClick={onReset} size="sm">
                        <FontAwesomeIcon icon={faUndo} className="me-1"/> Reset
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default MeasurementFilters;